import axios, { AxiosRequestConfig } from "axios"
import { Button } from "primereact/button"
import { InputText } from "primereact/inputtext"
import { useEffect, useRef, useState } from "react"
import { useAuth } from "../../../context/AuthProvider"
import { ConfirmDialog } from "primereact/confirmdialog"
import { Toast } from "primereact/toast"
import { supabaseClient } from "../../../config/supabase-client"
import { Dropdown } from "primereact/dropdown"


type Commodity = {
    id: string;
    label: string;
    code: string;
};

export const SubCommodityCreator = () => {
    const toast = useRef(null)

    const [label, setLabel] = useState('')
    const [code, setCode] = useState('')
    const [selectedCommodity, setSelectedCommodity] = useState<Commodity>()
    const [showDialog, setShowDialog] = useState(false)
    const [commodities, setCommodities] = useState<Commodity[]>([])

    const { session } = useAuth();

    useEffect(() => {
        const getCommodities = async () => {
            if (commodities.length === 0) {
                const { data, error } = await supabaseClient
                    .from('commodities')
                    .select("*");
                setCommodities(data)
            }
        }
        getCommodities()
    }, [])

    const handleSubmitClick = async () => {
        try {
            const config: AxiosRequestConfig = {
                headers: {
                    "Authorization": `Bearer ${session.access_token}`,
                }
            }
            await axios.post('/api/commodities/sub', { label, code, commodity_id: selectedCommodity?.id }, config)
            successToast()
            setLabel('')
            setCode('')
        }
        catch (error) {
            console.error(error)
            let errorMessage;
            
            if (axios.isAxiosError(error)) {
                const message = error.response?.data?.message || ''

                if (message.includes('commodities_code_key')) {
                    errorMessage = 'Code must be unique.'
                } else if (message.includes('commodities_label_key')) {
                    errorMessage = 'Label must be unique.'
                }
                failToast(errorMessage)
            } else {
                failToast()
            }
        }
    }

    const successToast = () => {
        toast.current.show({ severity: 'success', summary: 'Success', detail: 'Added subcommodity successfully!' });
    };

    const failToast = (err_text = null) => {
        toast.current.show({ severity: 'error', summary: 'Failed', detail: err_text || 'Failed to add commodity.' });
    };

    const isformValid = () => {
        return !!(label && code && selectedCommodity)
    }

    return (
        <>
            <div className="panel surface-200 h-full p-4 mt-3 border-round flex flex-column w-6 col-offset-3">
                <h2>Create SubCommodity</h2>
                <label htmlFor="label">Commodity:</label>
                <Dropdown
                    className="mb-3"
                    placeholder="Select a commodity"
                    invalid={!selectedCommodity}
                    onChange={(e) => setSelectedCommodity(e.value)}
                    value={selectedCommodity}
                    optionLabel="label"
                    options={commodities}
                    filter
                />
                <label htmlFor="label">Label:</label>
                <InputText className="mb-3" name="label" invalid={!label} value={label} onChange={e => setLabel(e.target.value)} />
                <label htmlFor="code">Code:</label>
                <InputText className="mb-3" name="code" invalid={!code} value={code} onChange={e => setCode(e.target.value)} />
                <Button
                    severity="success"
                    icon="pi pi-save"
                    label="Submit"
                    onClick={() => setShowDialog(true)}
                    disabled={!isformValid()}
                />
                <ConfirmDialog
                    visible={showDialog}
                    reject={() => setShowDialog(false)}
                    onHide={() => setShowDialog(false)}
                    accept={() => handleSubmitClick()}
                    header="Are you sure you want to create a SubCommodity with the following data?"
                    content={({ headerRef, contentRef, footerRef, hide, message }) => (
                        <div className="flex flex-column align-items-center p-5 surface-overlay border-round">
                            <div className="border-circle bg-primary inline-flex justify-content-center align-items-center h-6rem w-6rem -mt-8">
                                <i className="pi pi-question text-5xl"></i>
                            </div>
                            <span className="font-bold text-2xl block mb-2 mt-4" ref={headerRef}>
                                {message.header}
                            </span>
                            <div>
                                <p><strong>Commodity: </strong>{selectedCommodity?.label}</p>
                                <p><strong>Label: </strong>{label}</p>
                                <p><strong>Code: </strong>{code}</p>
                            </div>
                            <div className="flex align-items-center gap-2 mt-4">
                                <Button
                                    severity="success"
                                    label="Submit"
                                    onClick={(event) => {
                                        hide(event);
                                        handleSubmitClick();
                                    }}
                                    className="w-8rem"
                                ></Button>
                                <Button
                                    label="Cancel"
                                    outlined
                                    onClick={(event) => {
                                        hide(event);
                                        setShowDialog(false);
                                    }}
                                    className="w-8rem"
                                ></Button>
                            </div>
                        </div>
                    )}
                    acceptLabel='Submit'
                    rejectLabel='Cancel'
                />

                <Toast ref={toast} />

            </div>
        </>
    )
}